import { v4 as uuidv4 } from "uuid";
export class PAStepGridViewModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.defaultDuration = 0;
    }
}
export default class PAStepGridView extends PAStepGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
